module.exports = __webpack_public_path__ + "img/chan_yiqi.8001d490.jpg";